// extracted by mini-css-extract-plugin
module.exports = {"modalHeader":"styles_modalHeader__g2kpS","ctDialog":"styles_ctDialog__1Mm59","headModal":"styles_headModal__32yni","iconClose":"styles_iconClose__M_ebN"};